/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invalidemailaddress2Inputs */

const en_invalidemailaddress2 = /** @type {(inputs: Invalidemailaddress2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invalid email address`)
};

const de_invalidemailaddress2 = /** @type {(inputs: Invalidemailaddress2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ungültige E-Mail-Adresse`)
};

/**
* | output |
* | --- |
* | "Invalid email address" |
*
* @param {Invalidemailaddress2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const invalidemailaddress2 = /** @type {((inputs?: Invalidemailaddress2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invalidemailaddress2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_invalidemailaddress2(inputs)
	return de_invalidemailaddress2(inputs)
});
export { invalidemailaddress2 as "invalidEmailAddress" }